<div class="modal-header">
    <h5 class="modal-title">Edit Profile</h5>
    <button type="button" class="btn-close" (click)="dismiss()" aria-label="Close"></button>
</div>
<dirty-tracking [forms]="[profileForm]"></dirty-tracking>
<form class="" novalidate #profileForm="ngForm" [ngClass]="{'was-validated': submitAttempt}">
    <div class="modal-body">
        <h5 class="text-primary text-strong mb-3">User Profile</h5>
        <div class="row gx-3">
            <div class="col-md mb-3">
                <label for="userFirstName" class="form-label">First Name<sup class="text-danger">*</sup></label>
                <input type="text" focus-me class="form-control form-control-lg" id="userFirstName" name="userFirstName"
                    [(ngModel)]="profile.firstName" placeholder="First Name" required>
                <div class="invalid-feedback">
                    <i class="fas fa-exclamation-circle"></i> This field is required.
                </div>
            </div>
            <div class="col-md mb-3">
                <label for="userLastName" class="form-label">Last Name<sup class="text-danger">*</sup></label>
                <input type="text" class="form-control form-control-lg" id="userLastName" name="userLastName"
                    [(ngModel)]="profile.lastName" placeholder="Last Name" required>
                <div class="invalid-feedback">
                    <i class="fas fa-exclamation-circle"></i> This field is required.
                </div>
            </div>
        </div>
        <div class="row gx-3">
            <div class="col-md mb-3">
                <label for="userEmail" class="form-label">Email Address<sup class="text-danger">*</sup></label>
                <input type="email" class="form-control form-control-lg" id="userEmail" name="userEmail"
                    [(ngModel)]="profile.emailAddress" placeholder="Email Address" required>
                <div class="invalid-feedback">
                    <i class="fas fa-exclamation-circle"></i> This field is required.
                </div>
            </div>
        </div>
        <div class="row gx-3">
            <div class="col-md mb-3 custom-file-input">
                <label for="userProfilePhoto" class="form-label d-block">Photo</label>
                <div class="hidden-file-input">
                    <input type="file" ng2FileSelect [uploader]="uploader" />
                    <button type="button" class="btn btn-white btn-lg"><i class="far fa-upload"></i> Choose
                        File</button>
                </div>
            </div>
        </div>
        <div class="row gx-3" *ngIf="profile.avatar">
            <div class="col-md mb-3">
                <div class="position-relative">
                    <button type="button" class="btn btn-white floating-action-button top right" rel="tooltip"
                        data-bs-placement="top" title="Remove Photo" (click)="removeAvatar()"><i
                            class="far fa-times"></i></button>
                    <img [src]="profile.avatar.fileUrl" alt="profile photo" />
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline-black btn-round btn-lg" (click)="dismiss()"><i
                class="far fa-times"></i> Cancel</button>
        <button type="submit" class="btn btn-secondary btn-round btn-lg" (click)="save()"><i class="far fa-check"></i>
            Save</button>
    </div>
</form>